import axios from "axios";

// https://api.binance.com/api/v3/ticker/price?symbol=ADABRL

const api = axios.create({
    baseURL: "https://api.binance.com/api/v3/ticker/price?symbol=ADABRL"
});

export default api;